module.exports = __webpack_public_path__ + "static/img/3.9badfdc.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/gongzhumanghe/3.png
// module id = aBDB
// module chunks = 1